<template>
<section>
<div class="title">
  I am a component
</div>
</section>
  <!-- About End -->
</template>
<script>
export default {
  inheritAttrs: false,
  name: 'CustomComponent',
}
</script>
<style scoped>
.title {
  line-height: 32px;
  font-weight: 600;
  text-align: center;
  text-transform: none;
  color: #009579;
  letter-spacing: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/CustomComponent.vue